module.exports = __webpack_public_path__ + "img/yx2.ec0d1f2a.jpg";